import React from "react";
import PropTypes from "prop-types";
import { tokens } from "../../theme";

/**
 * Hard-block popup for an action that cannot run while the robot is docked.
 * States the reason with no override, since a disabled Start button alone doesn't say why.
 */
export const ChargingBlockedDialog = ({ open, onClose, actionLabel = "dispatched" }) => {
  if (!open) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.container}>
        <h2 style={styles.titleText}>Robot is charging</h2>
        <p style={styles.messageText}>
          This robot is currently charging and cannot be {actionLabel}. Please try again once
          charging is complete.
        </p>

        <div style={styles.buttonContainer}>
          <button style={{ ...styles.button, ...styles.primaryButton }} onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

ChargingBlockedDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  /** Verb phrase completing "…cannot be {actionLabel}", e.g. "dispatched", "sent on patrol". */
  actionLabel: PropTypes.string,
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    padding: "0 20px",
  },
  container: {
    backgroundColor: tokens.surface,
    borderRadius: "14px",
    padding: "24px",
    minWidth: "300px",
    maxWidth: "450px",
    boxShadow: tokens.shadowLg,
    textAlign: "center",
  },
  titleText: {
    fontSize: "18px",
    fontWeight: 700,
    color: tokens.text,
    marginTop: 0,
    marginBottom: "12px",
  },
  messageText: {
    fontSize: "14px",
    color: tokens.text2,
    lineHeight: "1.5",
    marginBottom: "24px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "12px",
  },
  button: {
    flex: "0 1 auto",
    minWidth: "120px",
    padding: "10px 16px",
    borderRadius: "9px",
    fontSize: "13.5px",
    fontWeight: 600,
    cursor: "pointer",
    border: "none",
    transition: "opacity 0.2s",
  },
  primaryButton: { backgroundColor: tokens.accent, color: "#fff", fontWeight: 700 },
};

export default ChargingBlockedDialog;
